export function generatePretendUserUrl(userIdentifier: string | number): string {
  return `${window.location.origin}/dashboard/back/entry?pretend_this_user=${encodeURIComponent(
    userIdentifier,
  )}`
}
